import { SearchRange } from "@/types/dto/search-filters/range-filter";

export default function rangeFilterFactory(data: any = {}) {
  return {
    fieldName: data.fieldName || "",
    maxValue: data.maxValue || "",
    minValue: data.minValue || "",
    fieldType: data.fieldType || "",
    fromValue: data.fromValue || "",
    toValue: data.toValue || ""
  } as SearchRange;
}

